module.exports = __webpack_public_path__ + "img/zoom-out.1d364a02.svg";